// extracted by mini-css-extract-plugin
export default {"wrapper":"VacationMaskOverlay_wrapper__3taf8"};